`use strict`;

class Draad_Accordion {

    constructor(node) {

        this.rootEl = node;
        this.buttonEl = this.rootEl.querySelector('.accordion__trigger');

        const controlsId = this.buttonEl.getAttribute('aria-controls');
        this.contentEl = document.getElementById(controlsId);

        this.open = this.buttonEl.getAttribute('aria-expanded') === 'true';

        // add event listeners
        this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));

    }

    onButtonClick() {
        this.toggle(!this.open);
    }

    toggle(open) {

        // don't do anything if the open state doesn't change
        if (open === this.open) {
            return;
        }

        // update the internal state
        this.open = open;

        // handle DOM updates
        this.buttonEl.setAttribute('aria-expanded', `${open}`);
        if (open) {
            this.contentEl.removeAttribute('hidden');
            this.contentEl.setAttribute('aria-hidden', 'false');
        } else {
            this.contentEl.setAttribute('aria-hidden', 'true');
            this.contentEl.setAttribute('hidden', 'hidden');
        }

    }

    // Add public open and close methods for convenience
    open() {
        this.toggle(true);
    }

    close() {
        this.toggle(false);
    }

}

// init accordions

document.addEventListener('DOMContentLoaded', () => {

    const accordions = document.querySelectorAll('.accordion__item');
    for (const accordion of accordions) {
        new Draad_Accordion(accordion);
    }

});